import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";

// css
import styles from "./addForm.module.scss";
import { Formik } from "formik";
import addServiceSchema from "./addService.schema";
import { successMessageToast } from "helpers/common";
import { cloneDeep } from "lodash";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useCreateServiceStatusMutation, useServiceStatusDetailsQuery, useUpdateServiceStatusMutation } from "store/services/serviceStatus";
import LoadingIndicator from "components/shared/LoadingIndicator";
import AppInputField from "components/shared/FormComponents/AppInputField";
import { CLIENT_TYPE_OPTIONS } from "config/constants";
import { CommonSelect, RequiredFieldAstrick } from "components/Common/Common";
import { SERVICE_STATUS_LIST } from "config/paths";

const AddServiceStatus = () => {

  const { id: statusId } = useParams();
  const editMode = !!statusId;
  const navigate = useNavigate();

  const [initialValues, setInitialValues] = useState({ module: "service", client_type: "", title: "", status: "active" });

  const { data: statusDetails, isLoading } = statusId ? useServiceStatusDetailsQuery(statusId) : {};
  const [createStatus, { isLoading: createStatusLoading }] = useCreateServiceStatusMutation();
  const [updateStatus, { isLoading: updateStatusLoading }] = useUpdateServiceStatusMutation();

  const handleSubmit = async (payload) => {

    try {

      const values = cloneDeep(payload);
      values.client_type = values.client_type.value

      const result = editMode ? await updateStatus({ data: values, statusId }) : await createStatus(values);

      if (result?.error) {
        console.error("Error creating School Client", result.error);
        return;
      };

      successMessageToast(result?.data?.message);
      navigate(SERVICE_STATUS_LIST);

    } catch (err) { console.error("Error creating School Client", err); };

  };

  useEffect(() => {

    if (!statusId) return;

    setInitialValues({
      ...initialValues,
      title: statusDetails?.title || "",
      client_type: CLIENT_TYPE_OPTIONS.find(item => item.value === statusDetails?.client_type) || "",
    });

  }, [statusDetails]);

  return (
    <>
      <section className={`${styles.addForm} position-relative py-4 addForm`}>
        <Container fluid={true}>
          <Row>
            <Col lg="12" className="my-2">
              <div className="pageHead pb-3 d-flex align-items-center">
                <Link
                  className="themeBlue fw-sbold back-to-btn"
                  to={SERVICE_STATUS_LIST}
                >
                  <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 12L0 6L6 0L7.425 1.4L2.825 6L7.425 10.6L6 12ZM18 14V10C18 9.16667 17.7083 8.45833 17.125 7.875C16.5417 7.29167 15.8333 7 15 7H8.825L12.425 10.6L11 12L5 6L11 0L12.425 1.4L8.825 5H15C16.3833 5 17.5625 5.4875 18.5375 6.4625C19.5125 7.4375 20 8.61667 20 10V14H18Z" fill="#1C1B1F" />
                  </svg> Back
                </Link>
                <h6 className="m-0 fw-bold themeBlue">
                  {editMode ? "Edit Service Categories" : "Create New Service Categories"}
                </h6>
              </div>
            </Col>
            {
              isLoading ? <LoadingIndicator /> : (
                <Col lg="12" className="my-2">
                  <Formik
                    initialValues={initialValues}
                    validationSchema={addServiceSchema}
                    onSubmit={handleSubmit}
                    enableReinitialize
                  >
                    {({
                      handleSubmit,
                      errors
                    }) => (
                      <Form onSubmit={handleSubmit}>
                        <div
                          className="py-3"
                          style={{ borderTop: "1px solid #41a2a84d" }}
                        >
                          <Row>
                            <Col md="4" sm="6" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0 d-flex"
                              >
                                Service Categories Title
                                <RequiredFieldAstrick />
                              </label>
                              <AppInputField
                                name="title"
                                type="text"
                                placeholder="Enter title "
                                className={`${styles.formControl} form-control`}
                                maxLength={50}
                              />
                            </Col>
                            <Col md="4" sm="6" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0 d-flex"
                              >
                                Select Client Type
                                <RequiredFieldAstrick />
                              </label>
                              <CommonSelect
                                name="client_type"
                                placeholder={"Select Client Type"}
                                option={CLIENT_TYPE_OPTIONS}
                              />
                            </Col>
                          </Row>
                        </div>
                        <Row className="mt-4">
                          <Col className="my-2" lg="12">
                            <div
                              className={`${styles.btnWrpper} btnWrpper d-flex align-items-center gap-10 pt-3`}
                              style={{ borderTop: "1px solid #41a2a84d" }}
                            >
                              <Button
                                className="d-flex align-items-center justify-content-center commonBtn"
                                type="submit"
                                disabled={createStatusLoading || updateStatusLoading}
                              >
                                {createStatusLoading || updateStatusLoading ? <LoadingIndicator inline /> : "Save"}
                              </Button>
                              <Button
                                className="d-flex align-items-center justify-content-center commonBtn borderedBtn bg-transparent"
                                type="button"
                                onClick={() => navigate(SERVICE_STATUS_LIST)}
                              >
                                Cancel
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    )}
                  </Formik>
                </Col>
              )
            }
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AddServiceStatus;
